import { render, staticRenderFns } from "./Round.vue?vue&type=template&id=11e4a730&scoped=true&"
import script from "./Round.vue?vue&type=script&lang=ts&"
export * from "./Round.vue?vue&type=script&lang=ts&"
import style0 from "./Round.vue?vue&type=style&index=0&id=11e4a730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e4a730",
  null
  
)

export default component.exports